import CloseIcon from '@mui/icons-material/Close';

export default CloseIcon;
